import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";

function YachtFilters({ yachts, onFilterChange }) {
    const initialFilters = {
        type: "all",
        lengthRange: "all",
        capacity: "all",
        year: "all",
        flag: "all",
        motor: "all",
        migo: "all",
        startDate: null,
        endDate: null,
    };

    const [filters, setFilters] = useState(initialFilters);

    // Benzersiz değerleri alma fonksiyonu
    const getUniqueValues = (key) => {
        return ["all", ...new Set(yachts.map((yacht) => yacht[key]))];
    };

    // Kapasite aralıkları
    const capacityRanges = {
        all: "Tüm Kapasiteler",
        "1-10": "1-10 kişi",
        "11-20": "11-20 kişi",
        "21-30": "21-30 kişi",
        "30+": "30+ kişi",
    };

    const handleFilterChange = (filterType, value) => {
        const newFilters = { ...filters, [filterType]: value };
        setFilters(newFilters);
        onFilterChange(newFilters);
    };

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        const newFilters = { ...filters, startDate: start, endDate: end };
        setFilters(newFilters);
        onFilterChange(newFilters);
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onFilterChange(initialFilters);
    };

    const handleSearch = () => {
        // Filtreleme işlemini başlat
        onFilterChange(filters);
    };

    // Ortak stil sınıfları
    const selectClass =
        "bg-white/5 border border-white/10 text-white rounded-xl px-4 py-2 focus:outline-none focus:border-blue-500 transition-colors w-full min-w-[200px]";
    const labelClass = "text-white/60 text-sm mb-1 block";

    return (
        <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-2 border border-white/10 relative z-40">
            <div className="flex items-center gap-5">
                <h4 className="text-md font-semibold text-white whitespace-nowrap px-3">
                    Filtreleme
                </h4>

                <div className="flex-1 overflow-x-auto pb-2">
                    <div className="flex gap-4 min-w-max items-end">
                        {/* Tarih Seçimi */}
                        <div className="flex-shrink-0">
                            <label className={labelClass}>Tarih Aralığı</label>
                            <DatePicker
                                selected={filters.startDate}
                                onChange={handleDateChange}
                                startDate={filters.startDate}
                                endDate={filters.endDate}
                                selectsRange
                                locale={tr}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Tarih seçin"
                                minDate={new Date()}
                                className={selectClass}
                                monthsShown={2}
                                popperClassName="z-[60]"
                                calendarClassName="z-[60]"
                            />
                        </div>

                        {/* Yat Tipi */}
                        <div className="flex-shrink-0">
                            <label htmlFor="type" className={labelClass}>
                                Yat Tipi
                            </label>
                            <select
                                id="type"
                                value={filters.type}
                                onChange={(e) =>
                                    handleFilterChange("type", e.target.value)
                                }
                                className={selectClass}
                            >
                                <option value="all">Tüm Tekneler</option>
                                <option value="1">Motor Yacht</option>
                                <option value="2">Sailing Yacht</option>
                                <option value="3">Catamaran</option>
                                <option value="4">Luxury Yacht</option>
                                <option value="5">Super Yacht</option>
                            </select>
                        </div>

                        {/* Kapasite */}
                        <div className="flex-shrink-0">
                            <label htmlFor="capacity" className={labelClass}>
                                Kapasite
                            </label>
                            <select
                                id="capacity"
                                value={filters.capacity}
                                onChange={(e) =>
                                    handleFilterChange(
                                        "capacity",
                                        e.target.value
                                    )
                                }
                                className={selectClass}
                            >
                                {Object.entries(capacityRanges).map(
                                    ([value, label]) => (
                                        <option key={value} value={value}>
                                            {label}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>

                        {/* Port */}
                        <div className="flex-shrink-0">
                            <label htmlFor="migo" className={labelClass}>
                                Limanlar
                            </label>
                            <select
                                id="migo"
                                value={filters.migo}
                                onChange={(e) =>
                                    handleFilterChange("migo", e.target.value)
                                }
                                className={selectClass}
                            >
                                {getUniqueValues("migo").map((migo) => (
                                    <option key={migo} value={migo}>
                                        {migo === "all" ? "Limanlar" : migo}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Ara Butonu */}
                        <div className="flex-shrink-0">
                            <button
                                onClick={handleSearch}
                                className="premium-button text-white text-sm px-4 py-1.5 rounded-full h-[41px] w-24"
                            >
                                Ara
                            </button>
                        </div>

                        {/* Filtreleri Sıfırla Butonu */}
                        <div className="flex-shrink-0">
                            <button
                                onClick={handleReset}
                                className="px-4 py-2 bg-white/5 hover:bg-white/10 text-white/60 hover:text-white rounded-xl transition-colors text-sm whitespace-nowrap h-[41px]"
                            >
                                Sıfırla
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default YachtFilters;
